import styles from './Pagination.module.css';

interface PaginationProps {
  page: number;
  pages: number;
  total: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange?: (limit: number) => void;
}

export function Pagination({
  page,
  pages,
  total,
  limit,
  onPageChange,
  onLimitChange,
}: PaginationProps) {
  if (total === 0) return null;

  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);

  // Build page numbers with ellipsis
  function getPageNumbers(): (number | '...')[] {
    if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);

    const result: (number | '...')[] = [1];
    if (page > 3) result.push('...');

    const start = Math.max(2, page - 1);
    const end = Math.min(pages - 1, page + 1);
    for (let i = start; i <= end; i++) result.push(i);

    if (page < pages - 2) result.push('...');
    if (pages > 1) result.push(pages);

    return result;
  }

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <span className={styles.total}>
          {startItem}–{endItem} sur {total}
        </span>
        {onLimitChange && (
          <div className={styles.limiter}>
            <select
              className={styles.limitSelect}
              value={limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
            >
              {[10, 25, 50, 100].map((v) => (
                <option key={v} value={v}>{v} / page</option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className={styles.controls}>
        <button
          className={styles.pageBtn}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          &lsaquo;
        </button>

        {getPageNumbers().map((p, i) =>
          p === '...' ? (
            <span key={`e${i}`} className={styles.ellipsis}>...</span>
          ) : (
            <button
              key={p}
              className={`${styles.pageBtn} ${p === page ? styles.pageBtnActive : ''}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          ),
        )}

        <button
          className={styles.pageBtn}
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          &rsaquo;
        </button>
      </div>
    </div>
  );
}
